
import SubfamilyMdl from '@/models/Warehouse/WhSubfamily'
import {
    generateFetchDataFunction,
    generateDeleteItemFunction,
} from '../DataTableService'


const dtFetchData = generateFetchDataFunction(SubfamilyMdl)
const dtDeleteItem = generateDeleteItemFunction(SubfamilyMdl)
// If we need a custom route for the show and edit view:
// const showEditRoute = 'custom_route'

export default {
    dtFetchData,
    dtDeleteItem,
    //showEditRoute
}
